import ButtonLoader from '../Button'

type RegisterButtonProps = {
  handleSubmit: () => void
  disabled: boolean
}

const RegisterButton = ({ handleSubmit, disabled }: RegisterButtonProps) => {
  return (
    <ButtonLoader
      onClick={handleSubmit}
      disabled={disabled}
      className="ejForm__button button button--yellow"
    >
      <span data-i18n="form.button">РЕГИСТРАЦИЯ</span>
    </ButtonLoader>
  )
}

export default RegisterButton
